import { render, staticRenderFns } from "./MfcConfirm.vue?vue&type=template&id=7c041c3f&scoped=true&"
import script from "./MfcConfirm.vue?vue&type=script&lang=js&"
export * from "./MfcConfirm.vue?vue&type=script&lang=js&"
import style0 from "./MfcConfirm.vue?vue&type=style&index=0&id=7c041c3f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c041c3f",
  null
  
)

export default component.exports